import { Fragment as _Fragment, jsx as _jsx } from "react/jsx-runtime";
import { useAuthContext } from './react-context';
import { useOAuthCallback } from './use-oauth-callback';
/** Auth will be the callback from OAuth. Here we'll retrieve the token and store it */
export const Auth = ({ children, destination, authConfig }) => {
    const { session } = useAuthContext();
    useOAuthCallback({ authConfig, destination });
    return session ? _jsx(_Fragment, { children: children }) : null;
};
